import React from "react";
import { getStrPlatformImg } from '../../_helpers/reusablefunctions/getStreamingIcons';

// Values may be full URLs or just IDs/handles; toUrl normalises both.
const isUrl = (v) => /^https?:\/\//i.test(String(v).trim());
const stripHandle = (v) => String(v).trim().replace(/^@/, '');
const buildUrl = (baseFn) => (v) => (isUrl(v) ? String(v).trim() : baseFn(stripHandle(v)));

// Each entry: which artist field to read, which icon key to render,
// and how to turn the raw value into a clickable URL.
const PLATFORMS = [
    { key: 'instagram', field: 'instagram', icon: 'Instagrammakereels', toUrl: buildUrl((h) => `https://www.instagram.com/${h}`), title: 'Instagram' },
    { key: 'spotify', field: 'spotify', icon: 'spotify', toUrl: buildUrl((id) => `https://open.spotify.com/artist/${id}`), title: 'Spotify' },
    { key: 'facebook', field: 'facebook', icon: 'facebook', toUrl: buildUrl((h) => `https://www.facebook.com/${h}`), title: 'Facebook' },
    { key: 'website', field: 'website', icon: 'website', toUrl: buildUrl((h) => `https://${h}`), title: 'Website' },
    { key: 'youtube', field: 'youtube', icon: 'youtube', toUrl: buildUrl((h) => `https://www.youtube.com/@${h}`), title: 'YouTube' },
    { key: 'twitter', field: 'twitter', icon: 'twitter', toUrl: buildUrl((h) => `https://twitter.com/${h}`), title: 'Twitter' },
    { key: 'apple_music', field: 'apple_music_id', icon: 'applemusic', toUrl: (v) => `https://music.apple.com/artist/${stripHandle(v)}`, title: 'Apple Music' },
];

const SocialIcon = ({ value, iconKey, title, toUrl, getStrPlatformImg }) => {
    if (!value) return null;

    return (
        <a
            href={toUrl(value)}
            target="_blank"
            rel="noreferrer"
            title={title}
        >
            <img
                src={getStrPlatformImg(iconKey)}
                alt={title}
                style={{ width: "20px", height: "20px" }}
            />
        </a>
    );
};

const ArtistList = ({ artists }) => {
    if (!artists || artists.length === 0)
        return <span className="text-muted">--</span>;

    return (
        <div className="d-flex flex-column gap-2">
            {artists.map((artist, idx) => (
                <div
                    key={artist.artist_id || idx}
                    className="p-2 rounded border bg-light d-flex align-items-center shadow-sm"
                    style={{ fontSize: "0.85rem" }}
                >
                    {/* Artist Info */}
                    <div className="d-flex flex-column flex-grow-1">
                        <span className="fw-semibold text-dark">{artist.artist_name}</span>
                        {artist.name && (
                            <span className="text-muted" style={{ fontSize: "0.75rem" }}>
                                {artist.name}
                            </span>
                        )}
                    </div>

                    {/* Social Icons */}
                    <div className="d-flex gap-2">
                        {PLATFORMS.map((p) => (
                            <SocialIcon
                                key={p.key}
                                value={artist[p.field]}
                                iconKey={p.icon}
                                title={p.title}
                                toUrl={p.toUrl}
                                getStrPlatformImg={getStrPlatformImg}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ArtistList;
